<div>
  <p-table [value]="pagination.data || []" stripedRows>
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of columns" [ngClass]="col.styleClass" class="text-center"
          style="text-transform: uppercase;">
          {{ col.header }}
        </th>
        <th class="text-center" *ngIf="actions?.length">Acções</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr [ngClass]="{'linha-nova': rowData.isNew}" (click)="onRowClick(rowData)"
        class="cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700">
        <td *ngFor="let col of columns" [ngClass]="col.styleClass" class="text-center"
          style="text-transform: uppercase;">
          <ng-container [ngSwitch]="col.type">
            <ng-container *ngSwitchCase="'tag'">
              <p-tag [value]="getFieldValue(rowData, col)" [severity]="getTagSeverity(col, rowData)"></p-tag>
            </ng-container>

            <ng-container *ngSwitchCase="'badge'">
              <p-badge [value]="getFieldValue(rowData, col)" [severity]="getBadgeSeverity(col, rowData)"></p-badge>
            </ng-container>

            <ng-container *ngSwitchCase="'radio'">
              <p-radioButton name="radioGroup" [value]="rowData" [formControl]="getRadioFormControl()"
                (onClick)="onRadioChange(rowData)"></p-radioButton>
            </ng-container>

            <!-- ⬇️ novo caso: DATE -->
            <ng-container *ngSwitchCase="'date'">
              <span *ngIf="col.tooltip && col.header" pTooltip="{{ col.tooltip }}">
                {{ getFieldValue(rowData, col) | date:(col.dateFormat || 'dd/MM/yyyy') }}
              </span>
              <span *ngIf="!col.tooltip && col.header">
                {{ getFieldValue(rowData, col) | date:(col.dateFormat || 'dd/MM/yyyy') }}
              </span>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <span *ngIf="col.tooltip && col.header" pTooltip="{{ col.tooltip }}">
                {{ getFieldValue(rowData, col) }}
              </span>
              <span *ngIf="!col.tooltip && col.header">
                {{ getFieldValue(rowData, col) }}
              </span>
            </ng-container>
          </ng-container>

        </td>

        <td class="text-center" *ngIf="actions?.length">
          <div *ngIf="rowData.menuActions?.length" class="flex justify-center" (click)="$event.stopPropagation()">
            <p-menu #menuRef [model]="rowData.menuActions" [popup]="true" appendTo="body"></p-menu>
            <p-button icon="pi pi-ellipsis-v" (click)="toggleMenu($event, menuRef)"></p-button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
    [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
    [alwaysShow]="alwaysShowPaginator && (pagination.totalRecords ?? 0) > 0"
    (pageChange)="onPageChange($event)">
  </app-paginator-control>
</div>

<!-- <td *ngFor="let col of columns" [ngClass]="col.styleClass" class="text-center"
          style="text-transform: uppercase;">
          <ng-container [ngSwitch]="col.type">
            <ng-container *ngSwitchCase="'tag'">
              <p-tag [value]="getFieldValue(rowData, col.field)" [severity]="getTagSeverity(col, rowData)"></p-tag>
            </ng-container>
            <ng-container *ngSwitchCase="'badge'">
              <p-badge [value]="getFieldValue(rowData, col.field)"
                [severity]="getBadgeSeverity(col, rowData)"></p-badge>
            </ng-container>
            <ng-container *ngSwitchCase="'radio'">
              <p-radioButton name="radioGroup" [value]="rowData" [formControl]="getRadioFormControl()"
                (onClick)="onRadioChange(rowData)">
              </p-radioButton>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <span *ngIf="col.tooltip && col.header" pTooltip="{{ col.tooltip }}">
                {{ getFieldValue(rowData, col.field) }}
              </span>
              <span *ngIf="!col.tooltip && col.header">
                {{ getFieldValue(rowData, col.field) }}
              </span>
            </ng-container>
          </ng-container>
        </td> -->
<!-- body -->
